<template>
  <div class="caseH">
    <img src="./image/caseH.png" alt="H">
  </div>
</template>

<script>
export default {
  name: 'CmhkH5CaseH',

  data () {
    return {

    };
  },

  mounted () {

  },

  methods: {

  },
};
</script>

<style lang="scss" scoped>
.caseH {
  position: relative;
  width: 100vw;
  height: 100vh;

  >img {
    width: 100%;
  }
}
</style>